module.exports = __webpack_public_path__ + "static/img/zhaozu.4e5c3d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhaozu.png
// module id = SZu4
// module chunks = 0